import React, { Fragment } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Stack,
  Alert,
  Collapse,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Tooltip,
  Radio,
  RadioGroup,
  FormLabel,
  Switch,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SelfSizingTextField from "./Widgets/selfSizingTextField";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MuiToggleButton from "@mui/material/ToggleButton";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";
import { styled } from "@mui/material/styles";
import { handleBooleanRadioButtonChange } from "../hooks/useAppsLogic";

const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: selectedColor,
  },
}));

const CustomDisableInput = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#888",
    color: "#888",
  },
}));

const CustomDisableInputSelect = styled(Select)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#888",
    color: "#888",
  },
}));

export default function PIAFormContent({
  // Form methods
  register,
  control,
  setValue,
  getValues,
  errors,
  isSuperAdmin,

  // State values
  generalOpen,
  setGeneralOpen,
  dataCollectionOpen,
  setDataCollectionOpen,
  dataProtectionOpen,
  setDataProtectionOpen,
  dataHandlingOpen,
  setDataHandlingOpen,
  otherOpen,
  setOtherOpen,
  genAIOpen,
  setGenAIOpen,
  approvalOpen,
  setApprovalOpen,
  recordsOfProcessingOpen,
  setRecordsOfProcessingOpen,

  // Data selection states
  processingPurposeSelected,
  setProcessingPurposeSelected,
  studentInfoSelected,
  setstudentInfoSelected,
  staffInfoSelected,
  setstaffInfoSelected,
  parentInfoSelected,
  setparentInfoSelected,
  alumniInfoSelected,
  setalumniInfoSelected,
  volunteerInfoSelected,
  setVolunteerInfoSelected,
  areaOfUseSelected,
  setareaOfUseSelected,
  collectionModesSelected,
  setCollectionModesSelected,
  gradesSelected,
  setgradesSelected,
  dataLocationSelected,
  setdataLocationSelected,
  transferSafeguardsSelected,
  setTransferSafeguardsSelected,
  securityMeasuresSelected,
  setSecurityMeasuresSelected,
  specialCategoryDataSelected,
  setSpecialCategoryDataSelected,

  // Boolean states
  cloudHosted,
  setCloudHosted,
  dataSinglePurpose,
  setDataSinglePurpose,
  gDPRCompliant,
  setgDPRCompliant,
  hasExternalLLMs,
  setHasExternalLLMs,
  automatedDecisionMaking,
  setAutomatedDecisionMaking,
  approved,
  setapproved,
  notApproved,
  setnotApproved,
  vendorConfirmed,
  setVendorConfirmed,
  llmTraining,
  setllmTraining,
  llmDataShared,
  setllmDataShared,
  vendorSpecialCategoryData,
  setVendorSpecialCategoryData,
  internetPIPublished,
  setinternetPIPublished,
  subcontractorDataProtection,
  setSubcontractorDataProtection,
  securityBreachInt,
  setSecurityBreachInt,
  internationalTransferFlag,
  setInternationalTransferFlag,

  // Date states
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  approvalDate,
  setApprovalDate,
  policyLastUpdated,
  setPolicyLastUpdated,
  lastAuditDate,
  setLastAuditDate,
  lastUpdatedDate,
  completedBy,

  // Numeric states
  commonSense,
  setCommonSense,
  coppa,
  setCoppa,
  gDPRComplianceLevel,
  setGDPRComplianceLevel,

  // Conditional show states
  otherAuditShow,
  setotherAuditShow,
  otherDepartmentsShow,
  setotherDepartmentsShow,
  cloudProviderOtherShow,
  setCloudProviderOtherShow,
  cloudProviderOtherValue,

  // List data
  vendorsToDisplay,
  processingPurposes,
  studentItems,
  staffItems,
  parentItems,
  alumniItems,
  volunteerItems,
  areaOfUseItems,
  grades,
  collectionModeItems,
  cloudProviderItems,
  auditFrequencyList,
  dataLocationItems,
  transferSafeguardsItems,
  securityMeasuresItems,
  specialCategoryDataItems,
  legalBasisForProcessingInfoItems,
  approverList,

  // Event handlers
  HandleChange,
  handleChipDelete,
  handleChipDeleteForApplicableDepts,
  handleCommonSenseChange,
  handleGDPRChange,
  handleCoppaChange,
  handleVendorConfirmedChange,
  handleAuditFrequencyChange,
  handleCloudProviderChange,
  handleApprovedChange,
  handleNotApprovedChange,
  handleSecurityBreachChange,
  handleSubcontractorRadioButtonChange,
  legalBasisForProcessingChange,
  closeSuccess,
  closeError,

  // Utilities
  getProperUrl,
  titleBoxBackgroundColour,
  isSchoolRecord,
  currentUser,
  isAdding,
  hasROPModule,
  successDialogOpen,
  errorDialogOpen,
  successMessage,
  editOrAddTitle,
}) {
  return (
    <div>
      <Collapse in={successDialogOpen}>
        <Stack spacing={2}>
          <Alert severity="success" onClose={() => closeSuccess()}>
            {successMessage}
          </Alert>
        </Stack>
      </Collapse>
      <Collapse in={errorDialogOpen}>
        <Stack spacing={2}>
          <Alert severity="error" onClose={() => closeError()}>
            An error occured
          </Alert>
        </Stack>
      </Collapse>
      {/* <DialogContentText>
              </DialogContentText> */}
      <form id="mainForm">
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="id"
            name="id"
            label="ID"
            fullWidth
            hidden
            margin="dense"
            {...register("id")}
          />
        </Grid>
        <Box px={1} py={0}>
          <Box
            sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }}
            px={2}
            py={1}
            onClick={() => setGeneralOpen(!generalOpen)}
          >
            <Grid container sx={{ justifyContent: "space-between" }}>
              <Typography variant="inherit" sx={{ fontWeight: "bold" }}>
                General Application Information
              </Typography>
              <Typography variant="inherit" sx={{ fontWeight: "bold" }}>
                {generalOpen ? <RemoveIcon /> : <AddIcon />}
              </Typography>
            </Grid>
          </Box>
          <Collapse in={generalOpen} width={"100%"}>
            <Box sx={{ border: 1 }} px={1} py={2}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <CustomDisableInput
                    disabled={!isSuperAdmin && !isAdding}
                    required
                    id="name"
                    name="name"
                    label="Application Name"
                    fullWidth
                    margin="dense"
                    {...register("name")}
                    error={errors.name ? true : false}
                  />
                  <Typography variant="inherit" color="error.main">
                    {errors.name?.message}
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <TextField
                    required
                    id="url"
                    name="url"
                    label="Application URL"
                    fullWidth
                    margin="dense"
                    {...register("url")}
                    error={errors.url ? true : false}
                  />
                  <Typography variant="inherit" color="error.main">
                    {errors.url?.message}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  style={{
                    paddingTop: "38px",
                    paddingRight: 0,
                    paddingLeft: "10px",
                  }}
                >
                  {/* <Button
                    sx={{ m: 0, p: 0, minWidth: 0.6 }}
                    variant="outlined"
                    // href={getProperUrl(getValues("url"))}
                    target="_blank"
                  >
                    Go
                  </Button> */}
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <FormControl
                    sx={{ m: 0, minWidth: 250, maxWidth: 300 }}
                    required
                  >
                    <InputLabel>Vendor</InputLabel>
                    <Controller
                      required
                      name="vendorId"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => (
                        <CustomDisableInputSelect
                          disabled={!isSuperAdmin && !isAdding}
                          required
                          defaultValue={0}
                          value={value}
                          label="Vendor"
                          onChange={(e) =>
                            setValue("vendorId", e.target.value, {
                              shouldValidate: true,
                            })
                          }
                        >
                          {vendorsToDisplay.map((vendor, index) => (
                            <MenuItem key={index} value={vendor.id}>
                              {vendor.name}
                            </MenuItem>
                          ))}
                        </CustomDisableInputSelect>
                      )}
                    />
                  </FormControl>
                  <Typography variant="inherit" color="error.main">
                    {errors.vendorId?.message}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={vendorConfirmed}
                          onChange={handleVendorConfirmedChange}
                        />
                      }
                      label="Vendor Confirmed"
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={2.9} sm={2.9} md={2.9}>
                  <InputLabel
                    sx={{
                      paddingTop: 1.5,
                      paddingRight: 0,
                      paddingLeft: 0,
                    }}
                  >
                    Common Sense Media:
                  </InputLabel>
                </Grid>
                <Grid item xs={3.9} sm={3.9} md={3.9}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                    >
                      <ToggleButtonGroup
                        value={commonSense}
                        exclusive
                        onChange={handleCommonSenseChange}
                      >
                        <ToggleButton value={2} selectedColor="green">
                          Pass
                        </ToggleButton>
                        <ToggleButton value={1} selectedColor="orange">
                          Warning
                        </ToggleButton>
                        <ToggleButton value={0} selectedColor="Red">
                          Fail
                        </ToggleButton>
                        <ToggleButton value={4} selectedColor="Grey">
                          N/A
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </RadioGroup>
                  </FormControl>
                  <Typography variant="inherit" color="error.main">
                    {errors.commonSense?.message}
                  </Typography>
                </Grid>
                <Grid item xs={4.5} sm={4.5} md={4.5}>
                  <TextField
                    id="url"
                    name="url"
                    label="CSM Software Evaluation URL"
                    fullWidth
                    {...register("evalUrl")}
                    error={errors.evalUrl ? true : false}
                  />
                  <Typography variant="inherit" color="error.main">
                    {errors.evalUrl?.message}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={0.7}
                  sm={0.7}
                  md={0.7}
                  style={{
                    paddingTop: "30px",
                    paddingRight: 0,
                    paddingLeft: "10px",
                  }}
                >
                  {/* <Button
                    sx={{ m: 0, p: 0, minWidth: 1 }}
                    variant="outlined"
                    // href={getProperUrl(getValues("evalUrl"))}
                    target="_blank"
                  >
                    Go
                  </Button> */}
                </Grid>
                <Grid item xs={2.3} sm={2.3} md={2.3}>
                  <InputLabel
                    sx={{
                      paddingTop: 1.5,
                      paddingRight: 0,
                      paddingLeft: 0,
                    }}
                  >
                    Compliance GDPR:
                  </InputLabel>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                    >
                      <ToggleButtonGroup
                        value={gDPRComplianceLevel}
                        exclusive
                        onChange={handleGDPRChange}
                      >
                        <ToggleButton value={2} selectedColor="green">
                          Certified
                        </ToggleButton>
                        <ToggleButton value={1} selectedColor="green">
                          Meets Criteria
                        </ToggleButton>
                        <ToggleButton value={0} selectedColor="Red">
                          Unkn
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </RadioGroup>
                  </FormControl>
                  <Typography variant="inherit" color="error.main">
                    {errors.commonSense?.message}
                  </Typography>
                </Grid>
                <Grid item xs={1} sm={1.1} md={1.1}>
                  <InputLabel
                    sx={{
                      paddingTop: 1.5,
                      paddingRight: 0,
                      paddingLeft: 0,
                    }}
                  >
                    COPPA:
                  </InputLabel>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                    >
                      <ToggleButtonGroup
                        value={coppa}
                        exclusive
                        onChange={handleCoppaChange}
                      >
                        <ToggleButton value={2} selectedColor="green">
                          Yes
                        </ToggleButton>
                        <ToggleButton value={1} selectedColor="orange">
                          Unkn
                        </ToggleButton>
                        <ToggleButton value={0} selectedColor="Red">
                          No
                        </ToggleButton>
                        <ToggleButton value={3} selectedColor="Grey">
                          N/A
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </RadioGroup>
                  </FormControl>
                  <Typography variant="inherit" color="error.main">
                    {errors.commonSense?.message}
                  </Typography>
                </Grid>
                <Grid item xs={11.5} sm={11.5} md={11.5} paddingRight={0}>
                  <SelfSizingTextField
                    required
                    initialValue={getValues("description")}
                    maxSize={1000}
                    errors={errors.description}
                    register={register}
                    name="description"
                    id="description"
                    label="Description of Application"
                    placeholder="Description of Application"
                  ></SelfSizingTextField>
                </Grid>
                <Grid
                  item
                  xs={0.5}
                  sm={0.5}
                  md={0.5}
                  paddingLeft={0.5}
                  style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}
                >
                  <Tooltip title="Description of the application and why private data is needed.">
                    <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                  </Tooltip>
                </Grid>
                <Grid item xs={5} sm={5}>
                  <MultiSelectWithChips
                    label="Processing Purpose"
                    name="processingPurposeSelected"
                    control={control}
                    backgroundColor="#ecf7eb"
                    value={processingPurposeSelected}
                    infoSelected={processingPurposeSelected}
                    setinfoSelected={setProcessingPurposeSelected}
                    onChange={HandleChange}
                    handleChipDelete={handleChipDelete}
                    errors={errors.processingPurposeSelected}
                    items={processingPurposes}
                  ></MultiSelectWithChips>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  style={{
                    paddingTop: "20px",
                    paddingRight: 0,
                    paddingLeft: "0px",
                  }}
                >
                  <Tooltip title="Description: This field describes why the school uses this application and what educational or operational function it supports...">
                    <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={12} paddingRight={0}>
                  <SelfSizingTextField
                    initialValue={getValues("processingPurposeDescription")}
                    maxSize={1000}
                    backgroundColor="#ecf7eb"
                    errors={errors.processingPurposeDescription}
                    register={register}
                    name="processingPurposeDescription"
                    id="processingPurposeDescription"
                    dupefield="processingPurposeDescriptionr"
                    setfunction={setValue}
                    label="Processing Purpose Description"
                    placeholder="Description of the processing purpose."
                  ></SelfSizingTextField>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Cloud Hosted *
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      {...register("cloudHosted")}
                      onChange={(e) => {
                        handleBooleanRadioButtonChange(e, setCloudHosted);
                      }}
                    >
                      <FormControlLabel
                        {...register("cloudHosted")}
                        key="1"
                        value={"1"}
                        checked={cloudHosted}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        {...register("cloudHosted")}
                        key="0"
                        value={"0"}
                        checked={cloudHosted === false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Typography variant="inherit" color="error.main">
                    {errors.cloudHosted?.message}
                  </Typography>
                </Grid>
                {cloudHosted && (
                  <Grid item xs={4} sm={4}>
                    <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>
                      <InputLabel sx={{ paddingTop: 1.5 }}>
                        Cloud Provider
                      </InputLabel>
                      <Controller
                        name="cloudProviderId"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            id="cloudProviderId"
                            value={value}
                            label="Cloud Provider"
                            onChange={(e) =>
                              handleCloudProviderChange(e, cloudProviderOtherValue)
                            }
                          >
                            {cloudProviderItems.map((mode, index) => (
                              <MenuItem
                                key={index}
                                value={mode.lookupItemId}
                              >
                                {mode.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </FormControl>
                    <Typography variant="inherit" color="error.main">
                      {errors.cloudProviderId?.message}
                    </Typography>
                  </Grid>
                )}
                {cloudHosted && cloudProviderOtherShow && (
                  <Fragment>
                    <Grid item xs={4} sm={4}>
                      <FormControl sx={{ m: 0, minWidth: 200 }}>
                        <TextField
                          id="cloudProvider"
                          name="cloudProvider"
                          label="Other Cloud Provider"
                          fullWidth
                          margin="dense"
                          {...register("cloudProvider")}
                          error={errors.cloudProvider ? true : false}
                        />
                      </FormControl>
                      <Typography variant="inherit" color="error.main">
                        {errors.cloudProvider?.message}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "5px",
                      }}
                    >
                      <Tooltip title="What cloud service is hosting the application?">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                  </Fragment>
                )}
                <Grid item xs={12} sm={12} md={12} paddingTop={1}>
                  <Typography variant="inherit">
                    To Be Completed by Organization &nbsp;&nbsp;
                  </Typography>
                </Grid>
                <Grid
                  container
                  border={0}
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{
                    paddingTop: "10px",
                    paddingLeft: "20px",
                    paddingBottom: "10px",
                  }}
                >
                  <Grid
                    container
                    border={1}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      paddingTop: "10px",
                      paddingLeft: "20px",
                      paddingBottom: "10px",
                    }}
                  >
                    <Grid item xs={4} sm={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box
                          sx={{
                            width: "100%",
                            border: 1,
                            borderColor: "red",
                            borderRadius: 1,
                            padding: 1,
                          }}
                        >
                          <DatePicker
                            sx={{
                              width: "100%",
                              "& .MuiInputLabel-root": {
                                color: "red",
                                "&.Mui-focused": { color: "violet" },
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "red" },
                                "&:hover fieldset": { borderColor: "red" },
                                "&.Mui-focused fieldset": {
                                  borderColor: "red !important",
                                },
                              },
                              "& .MuiSvgIcon-root": { color: "red" },
                            }}
                            id="startDate"
                            name="startDate"
                            label="Date Started"
                            {...register("startDate")}
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              setValue("startDate", newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Box>
                      </LocalizationProvider>
                      <Typography variant="inherit" color="error.main">
                        {errors.startDate?.message}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "5px",
                      }}
                    >
                      <Tooltip title="The date you started using the application.">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                      <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                        <Box
                          sx={{
                            width: "100%",
                            border: 1,
                            borderColor: "red",
                            borderRadius: 1,
                            padding: 1,
                          }}
                        >
                          <DatePicker
                            id="endDate"
                            name="endDate"
                            label="Date Ended"
                            {...register("endDate")}
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              setValue("endDate", newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Box>
                      </LocalizationProvider>
                      <Typography variant="inherit" color="error.main">
                        {errors.endDate?.message}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "5px",
                      }}
                    >
                      <Tooltip title="The date you stopped using the application - needed for historical reporting.">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} />
                    {!(!isSuperAdmin || true) && (
                      <Grid item xs={6} sm={6}>
                        <FormControl sx={{ m: 0, minWidth: 200 }}>
                          <InputLabel>Institution Point of Contact </InputLabel>
                          <Controller
                            name="itOwnerId"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                              <Select
                                defaultValue={0}
                                value={value}
                                label="Institution Point of Contact"
                                onChange={(e) =>
                                  setValue("itOwnerId", e.target.value, {
                                    shouldValidate: true,
                                  })
                                }
                              >
                                {/* itOwners map */}
                              </Select>
                            )}
                          />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.itOwner?.message}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={5} sm={5}>
                      <FormControl sx={{ m: 0, minWidth: 200 }}>
                        <MultiSelectWithChips
                          borderColor="red"
                          label="Collection Mode"
                          name="collectionModesSelected"
                          control={control}
                          value={collectionModesSelected}
                          infoSelected={collectionModesSelected}
                          setinfoSelected={setCollectionModesSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.collectionModesSelected}
                          items={collectionModeItems}
                        ></MultiSelectWithChips>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "0px",
                      }}
                    >
                      <Tooltip title="How is the student data transfered to the third party application?">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                    {collectionModesSelected.indexOf("Other") !== -1 && (
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <FormControl sx={{ m: 0, minWidth: 400 }}>
                          <TextField
                            id="collectionModeOther"
                            name="collectionModeOther"
                            label="Other Collection Mode"
                            fullWidth
                            margin="dense"
                            {...register("collectionModeOther")}
                            error={errors.collectionModeOther ? true : false}
                          />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.collectionModeOther?.message}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={5} sm={5}>
                      <MultiSelectWithChips
                        borderColor="red"
                        label="Applicable Grades"
                        name="gradesSelected"
                        control={control}
                        value={gradesSelected}
                        infoSelected={gradesSelected}
                        //infoNASelected={gradesNASelected}
                        setinfoSelected={setgradesSelected}
                        onChange={HandleChange}
                        handleChipDelete={handleChipDelete}
                        errors={errors.gradesSelected}
                        items={grades}
                      ></MultiSelectWithChips>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "0px",
                      }}
                    >
                      <Tooltip title="What grade are using the application - important for reporting.">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={5} sm={5}>
                      <MultiSelectWithChips
                        borderColor="red"
                        label="Department of Responsibility"
                        name="areaOfUseSelected"
                        control={control}
                        backgroundColor="#ecf7eb"
                        value={areaOfUseSelected}
                        infoSelected={areaOfUseSelected}
                        setinfoSelected={setareaOfUseSelected}
                        onChange={HandleChange}
                        handleChipDelete={handleChipDeleteForApplicableDepts}
                        errors={errors.areaOfUseItems}
                        items={areaOfUseItems}
                      ></MultiSelectWithChips>
                      <Typography variant="inherit" color="error.main">
                        {errors.areaOfUseSelected?.message}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        paddingTop: "20px",
                        paddingRight: 0,
                        paddingLeft: "0px",
                      }}
                    >
                      <Tooltip title="What department(s) are using this software?">
                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                      </Tooltip>
                    </Grid>
                    {otherDepartmentsShow && (
                      <Grid item xs={6} style={{ paddingTop: 25 }}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          id="applicableDepartmentsOther"
                          name="applicableDepartmentsOther"
                          label="Other Applicable Departments"
                          fullWidth
                          placeholder="Other Applicable Departments"
                          {...register("applicableDepartmentsOther")}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.applicableDepartmentsOther?.message}
                        </Typography>
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={4.5}
                      sm={4.5}
                      md={4.5}
                      style={{ paddingTop: 10 }}
                    >
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                          },
                        }}
                        id="url"
                        name="url"
                        label="Contract URL"
                        fullWidth
                        {...register("contractUrl")}
                        error={errors.contractUrl ? true : false}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.contractUrl?.message}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={0.7}
                      sm={0.7}
                      md={0.7}
                      style={{
                        paddingTop: "30px",
                        paddingRight: 0,
                        paddingLeft: "10px",
                      }}
                    >
                      <Button
                        sx={{ m: 0, p: 0, minWidth: 1 }}
                        variant="outlined"
                        href={getProperUrl(getValues("contractUrl"))}
                        target="_blank"
                      >
                        Go
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={11}>
                  <SelfSizingTextField
                    required={false}
                    initialValue={getValues("generalApplicationNotes")}
                    maxSize={2000}
                    errors={errors.generalApplicationNotes}
                    register={register}
                    name="generalApplicationNotes"
                    id="generalApplicationNotes"
                    label="General Application Notes"
                    placeholder="General Application Notes"
                  ></SelfSizingTextField>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  style={{
                    paddingTop: "20px",
                    paddingRight: 0,
                    paddingLeft: "5px",
                  }}
                >
                  <Tooltip title="Any other general information that is needed to be kept by the school.">
                    <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                  </Tooltip>
                </Grid>
              </Grid>
            </Box>
          </Collapse>

          {/* Additional sections would go here - Data Collection, Data Protection, etc. */}
          {/* Due to length, these sections are abbreviated in this file */}
          {/* Include other sections similarly to the General Application Information section */}

        </Box>
      </form>
    </div>
  );
}
